// PPE 2.0 (DEV-4849): CRUD client for the margin expression-tree family (MarginCriteriaController).
// Structural sibling of adjustmentCriteriaApi. Every call skips the global forbidden-reload: the GET
// degrades to seed rules, and WRITES surface a 403 inline via the thunk mutation-error slice (incl. the
// tier-3 fair-lending rejection) instead of triggering the page-reload interceptor.
import { SKIP_FORBIDDEN } from './httpConfig';

export class MarginCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria(params) {
    return this.#http.get('/api/margin-criteria', { ...SKIP_FORBIDDEN, params });
  }

  async createCriteria(body) {
    return this.#http.post('/api/margin-criteria', body, SKIP_FORBIDDEN);
  }

  async editCriteria(criteriaId, body) {
    return this.#http.put(`/api/margin-criteria/${criteriaId}`, body, SKIP_FORBIDDEN);
  }

  async deleteCriteria(criteriaId) {
    return this.#http.delete(`/api/margin-criteria/${criteriaId}`, SKIP_FORBIDDEN);
  }
}
